<!-- results-table.component.html -->
<h1 mat-dialog-title>
    <strong>{{ action | translate }}</strong> moneda
    <span *ngIf="action == 'Delete'"> {{ LOCAL_DATA.nombre }}</span>
</h1>
<div mat-dialog-content fxLayout="column">
    <div fxFlex>
        <mat-form-field *ngIf="action != 'Delete'" fxFlex>
            <input
                placeholder="Nombre"
                matInput
                [(ngModel)]="LOCAL_DATA.nombre"
                [disabled]="action == 'View'"
            />
        </mat-form-field>
    </div>
    <div fxFlex>
        <mat-form-field *ngIf="action != 'Delete'" fxFlex>
            <input
                placeholder="Simbolo"
                matInput
                [(ngModel)]="LOCAL_DATA.simbolo"
                [disabled]="action == 'View'"
            />
        </mat-form-field>
    </div>
    <div fxFlex>
        <mat-form-field *ngIf="action != 'Delete'" fxFlex>
            <input
                placeholder="Factor de riesgo"
                matInput
                [(ngModel)]="LOCAL_DATA.factorDeRiesgo"
                [disabled]="action == 'View'"
                step="0.1"
                type="number"
                min="0.1"
                max="9.9"
            />
        </mat-form-field>
    </div>
    <div fxFlex>
        <!--<mat-form-field *ngIf="action != 'Delete'" class="select-list" fxFlex>
      <mat-label>País</mat-label>
      <mat-select [(ngModel)]="LOCAL_DATA.pais" class="roleSelect"
          [disabled]="action == 'View'" [compareWith]="compareObjects">
          <mat-option *ngFor="let pais of paises" [value]="pais">
              {{pais.nombre}}
          </mat-option>
      </mat-select>
    </mat-form-field>-->

        <mat-form-field fxFlex *ngIf="action != 'Delete'">
            <mat-label>País</mat-label>
            <input
                type="text"
                placeholder="País"
                aria-label="País"
                matInput
                [formControl]="tipoCtrl"
                [matAutocomplete]="auto"
                [(ngModel)]="LOCAL_DATA.pais"
            />

            <mat-autocomplete
                autoActiveFirstOption
                #auto="matAutocomplete"
                [displayWith]="displayFn.bind(this)"
            >
                <mat-option
                    *ngFor="let pais of filteredPaises | async"
                    [value]="pais"
                >
                    {{ pais.nombre }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>
</div>
<div mat-dialog-actions>
    <button
        mat-button
        (click)="doAction()"
        *ngIf="action != 'View'"
        [disabled]="
            action != 'Delete' &&
            (LOCAL_DATA.simbolo == '' ||
                LOCAL_DATA.simbolo == null ||
                LOCAL_DATA.nombre == '' || LOCAL_DATA.nombre == null ||
                LOCAL_DATA.pais == null)
        "
    >
        {{ action | translate }}
    </button>
    <button mat-button (click)="closeDialog()" mat-flat-button color="warn">
        {{ "Cancel" | translate }}
    </button>
</div>
